import React from 'react';
import Autocomplete from '@nib/autocomplete';
import { errorMessage, isValid, isTouched, isFieldOptionalAndEmpty } from '../../util/validationHelpers';
import { combineHandlerWithFormik } from '../../util/eventHelpers';
const BaseAutoComplete = props => {
  var _a;
  const {
    label,
    options,
    suggestionList,
    width,
    name,
    id = '',
    help = '',
    optional = false,
    field,
    valid,
    validated,
    error,
    onBlur,
    onChange,
    formikOnChange,
    ...otherProps
  } = props;
  // if a field is optional and empty we don't want to show the green validation tick
  let fieldOptionalAndEmpty = optional;
  const inputName = field === null || field === void 0 ? void 0 : field.name;
  // Purely for storybook knobs to work
  const validState = typeof valid !== 'undefined' ? valid : isValid({
    ...otherProps,
    id
  });
  const validatedState = typeof validated !== 'undefined' ? validated : isTouched({
    ...otherProps,
    id
  });
  const errorState = typeof error !== 'undefined' ? error : errorMessage({
    ...otherProps,
    id
  });
  let formikChangeEvent = e => props.form.setFieldValue(id, e);
  const formikBlurEvent = () => props.form.setFieldTouched(id, true);
  const formikOnFocus = () => props.form.setFieldTouched(id, false);
  // optionally a developer can pass in their own onchange / onblur events to fire, an example is to create a function that fires off multiple setFieldValue, setFieldTouched
  if (formikOnChange) {
    formikChangeEvent = e => formikOnChange(id, e, props.form);
  }
  let handleChange = formikChangeEvent;
  const handleBlur = combineHandlerWithFormik(formikBlurEvent, onBlur);
  handleChange = combineHandlerWithFormik(formikChangeEvent, onChange);
  fieldOptionalAndEmpty = isFieldOptionalAndEmpty(optional, field);
  const handleOnFocus = formikOnFocus;
  return React.createElement(Autocomplete, {
    id: id,
    label: label,
    help: help,
    valid: validState,
    validated: validatedState,
    error: errorState,
    width: width,
    options: options,
    suggestions: suggestionList,
    keys: ['value', 'text', 'aliases'],
    field: field,
    ...field,
    onChange: handleChange,
    onBlur: handleBlur,
    onFocus: handleOnFocus,
    value: (_a = field === null || field === void 0 ? void 0 : field.value) !== null && _a !== void 0 ? _a : '',
    isEmptyAndOptional: fieldOptionalAndEmpty,
    optional: optional,
    ...otherProps,
    name: inputName
  });
};
BaseAutoComplete.defaultProps = {
  help: '',
  optional: false
};
export default BaseAutoComplete;